export default __webpack_public_path__ + "static/media/addIcon.4f683076.svg";